<div class="person-demographics-part d-flex flex-column justify-content-between gap-2 h-100">

	<div class="d-flex flex-column gap-2">
		<common-select-field [field]="demographicsForm.gender()"></common-select-field>
		<common-text-field [field]="demographicsForm.genderOther()"></common-text-field>
		<common-multiselect-field [field]="demographicsForm.races()"></common-multiselect-field>
		<common-select-field [field]="demographicsForm.hispanicOrLatino()"></common-select-field>
		<common-date-time-field [field]="demographicsForm.birthday()"></common-date-time-field>
		<common-select-field [field]="demographicsForm.veteran()"></common-select-field>
		<common-select-field [field]="demographicsForm.nativeEnglish()"></common-select-field>
		<common-select-field [field]="demographicsForm.nativeSpanish()"></common-select-field>

		<div class="statusFields">
			@for(key of this.STATUS_FLAGS; track key ){
			<div class="d-flex gap-2 mb-2">
				<input id="statusFlags" class="form-check-input fs-6" type="checkbox"
					[ngModel]="demographicsForm.personStatusFlags()[key]" (ngModelChange)="updateStatusFlags(key, $event)">
				<label class="fs-6" for="statusFlags">
					{{key}}
				</label>
			</div>
			}
		</div>
	</div>

	<common-button-row [center]="true">
		<button class="btn btn-standard" (click)="showViewMode()">View</button>
		<button class="btn btn-standard" (click)="setInitialValues()">Revert</button>
		<button #demographicsSaveBtn class="btn btn-primary">Save Changes</button>
		<button class="btn btn-standard" (click)="onClose()">Close</button>
	</common-button-row>
</div>